import React from 'react';
import './style.scss';
var CheckboxAndRadio = function CheckboxAndRadio(_ref) {
  var name = _ref.name,
    id = _ref.id,
    value = _ref.value,
    label = _ref.label,
    checked = _ref.checked,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    type = _ref.type;
  return /*#__PURE__*/React.createElement("div", {
    className: "Checkbox"
  }, /*#__PURE__*/React.createElement("input", {
    type: type || 'checkbox',
    className: "Checkbox__input",
    name: name,
    id: id,
    value: value,
    checked: checked,
    onChange: onChange,
    disabled: disabled
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: id,
    className: "icon-before icon-checkmark"
  }, label));
};
export default CheckboxAndRadio;